import { DotsThreeVertical, Info, Pencil, Trash } from "@phosphor-icons/react";
import { useState } from "react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { Section } from "./section";

export function DataDisplaySection() {
	const [tabValue, setTabValue] = useState("tab1");

	return (
		<>
			<Section title="Tabs">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-col gap-4">
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">
									Wariant domyślny
								</p>
								<Tabs value={tabValue} onValueChange={setTabValue}>
									<TabsList>
										<TabsTrigger value="tab1">Zakładka 1</TabsTrigger>
										<TabsTrigger value="tab2">Zakładka 2</TabsTrigger>
										<TabsTrigger value="tab3">Zakładka 3</TabsTrigger>
									</TabsList>
									<TabsContent value="tab1">
										<p className="text-muted-foreground p-2">
											Zawartość pierwszej zakładki.
										</p>
									</TabsContent>
									<TabsContent value="tab2">
										<p className="text-muted-foreground p-2">
											Zawartość drugiej zakładki.
										</p>
									</TabsContent>
									<TabsContent value="tab3">
										<p className="text-muted-foreground p-2">
											Zawartość trzeciej zakładki.
										</p>
									</TabsContent>
								</Tabs>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Wariant liniowy</p>
								<Tabs defaultValue="a">
									<TabsList variant="line">
										<TabsTrigger value="a">Przegląd</TabsTrigger>
										<TabsTrigger value="b">Szczegóły</TabsTrigger>
										<TabsTrigger value="c">Historia</TabsTrigger>
									</TabsList>
									<TabsContent value="a">
										<p className="text-muted-foreground p-2">
											Treść przeglądu.
										</p>
									</TabsContent>
									<TabsContent value="b">
										<p className="text-muted-foreground p-2">
											Treść szczegółów.
										</p>
									</TabsContent>
									<TabsContent value="c">
										<p className="text-muted-foreground p-2">Treść historii.</p>
									</TabsContent>
								</Tabs>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>

			<Section title="Tabela">
				<Card>
					<CardContent className="pt-6">
						<Table>
							<TableHeader>
								<TableRow>
									<TableHead>Nazwa</TableHead>
									<TableHead>Status</TableHead>
									<TableHead className="text-right">Wartość</TableHead>
								</TableRow>
							</TableHeader>
							<TableBody>
								<TableRow>
									<TableCell className="font-medium">Licznik #001</TableCell>
									<TableCell>Aktywny</TableCell>
									<TableCell className="text-right">123.45</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className="font-medium">Licznik #002</TableCell>
									<TableCell>Nieaktywny</TableCell>
									<TableCell className="text-right">67.89</TableCell>
								</TableRow>
								<TableRow>
									<TableCell className="font-medium">Licznik #003</TableCell>
									<TableCell>Aktywny</TableCell>
									<TableCell className="text-right">245.12</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</CardContent>
				</Card>
			</Section>

			<Section title="Avatar">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-wrap items-center gap-4">
							<div className="flex flex-col items-center gap-2">
								<Avatar size="lg">
									<AvatarImage src="https://api.dicebear.com/9.x/initials/svg?seed=JD" />
									<AvatarFallback>JD</AvatarFallback>
								</Avatar>
								<p className="text-xs text-muted-foreground">Large</p>
							</div>
							<div className="flex flex-col items-center gap-2">
								<Avatar>
									<AvatarImage src="https://api.dicebear.com/9.x/initials/svg?seed=AK" />
									<AvatarFallback>AK</AvatarFallback>
								</Avatar>
								<p className="text-xs text-muted-foreground">Default</p>
							</div>
							<div className="flex flex-col items-center gap-2">
								<Avatar size="sm">
									<AvatarFallback>SM</AvatarFallback>
								</Avatar>
								<p className="text-xs text-muted-foreground">Small</p>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>

			<Section title="Tooltip & Menu">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-wrap items-center gap-4">
							<Tooltip>
								<TooltipTrigger asChild>
									<Button variant="outline" size="sm">
										<Info className="size-4 mr-1" />
										Najedź na mnie
									</Button>
								</TooltipTrigger>
								<TooltipContent>
									<p>To jest przykładowy tooltip</p>
								</TooltipContent>
							</Tooltip>

							<DropdownMenu>
								<DropdownMenuTrigger asChild>
									<Button variant="outline" size="icon">
										<DotsThreeVertical className="size-4" />
									</Button>
								</DropdownMenuTrigger>
								<DropdownMenuContent>
									<DropdownMenuLabel>Akcje</DropdownMenuLabel>
									<DropdownMenuSeparator />
									<DropdownMenuItem>
										<Pencil className="size-4 mr-1.5" />
										Edytuj
									</DropdownMenuItem>
									<DropdownMenuItem variant="destructive">
										<Trash className="size-4 mr-1.5" />
										Usuń
									</DropdownMenuItem>
								</DropdownMenuContent>
							</DropdownMenu>

							<AlertDialog>
								<AlertDialogTrigger asChild>
									<Button variant="destructive" size="sm">
										Alert Dialog
									</Button>
								</AlertDialogTrigger>
								<AlertDialogContent>
									<AlertDialogHeader>
										<AlertDialogTitle>Czy na pewno?</AlertDialogTitle>
										<AlertDialogDescription>
											Tej operacji nie można cofnąć. Dane zostaną trwale
											usunięte.
										</AlertDialogDescription>
									</AlertDialogHeader>
									<AlertDialogFooter>
										<AlertDialogCancel>Anuluj</AlertDialogCancel>
										<AlertDialogAction variant="destructive">
											Usuń
										</AlertDialogAction>
									</AlertDialogFooter>
								</AlertDialogContent>
							</AlertDialog>
						</div>
					</CardContent>
				</Card>
			</Section>
		</>
	);
}
